import React, { useId } from 'react';

export function Input({
  as: Component = 'input',
  id: explicitId,
  label,
  error,
  hint,
  leftIcon,
  rightIcon,
  required = false,
  disabled = false,
  className = '',
  wrapperClassName = '',
  type = 'text',
  children, // for <select> options
  ...props
}) {
  const generatedId = useId();
  const inputId = explicitId || generatedId;
  const hintId = hint ? `${inputId}-hint` : undefined;
  const errorId = error ? `${inputId}-error` : undefined;

  const hasLeft = Boolean(leftIcon);
  const hasRight = Boolean(rightIcon);

  const inputClasses = [
    Component === 'textarea' ? 'bza-textarea' : Component === 'select' ? 'bza-select' : 'bza-input',
    hasLeft ? 'bza-input-has-left' : '',
    hasRight ? 'bza-input-has-right' : '',
    error ? 'bza-input-error' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={`bza-form-group ${wrapperClassName}`}>
      {label && (
        <label htmlFor={inputId} className="bza-label">
          {label}
          {required && <span className="bza-label-required" aria-hidden="true">*</span>}
        </label>
      )}

      <div className="bza-input-wrap">
        {hasLeft && <span className="bza-input-icon-left">{leftIcon}</span>}

        <Component
          id={inputId}
          type={Component === 'input' ? type : undefined}
          required={required}
          disabled={disabled}
          className={inputClasses}
          aria-invalid={error ? 'true' : 'false'}
          aria-describedby={error ? errorId : hint ? hintId : undefined}
          {...props}
        >
          {children}
        </Component>

        {hasRight && <span className="bza-input-icon-right">{rightIcon}</span>}
      </div>

      {error ? (
        <span id={errorId} className="bza-input-error-msg" role="alert">
          {error}
        </span>
      ) : hint ? (
        <span id={hintId} className="bza-input-hint">
          {hint}
        </span>
      ) : null}
    </div>
  );
}

export default Input;
